import { Configuration } from 'store/configurations';
import { ClientIntegration } from 'store/media';

export enum Selections {
  EVENT_IMAGES = 'eventImages',
  VENUE_IMAGES = 'venueImages',
  GENRE_IMAGES = 'genreImages',
  UPPER_DECK = 'upperDeck',
  LOWER_DECK = 'lowerDeck',
  OTHER_IMAGES = 'otherImages'
}

export enum MediaTypes {
  EVENT = 'event',
  VENUE = 'venue',
  GENRE = 'genre',
  UPPER_IMAGE = 'upper-image',
  UPPER_VIDEO = 'upper-video',
  ATTRACT_IMAGE = 'attract-image',
  ATTRACT_VIDEO = 'attract-video',
  DISABLE_MEDIA = 'disable-media',
  INACTIVE_IMAGE = 'inactive-image',
  SPLASH_IMAGE = 'splash-image',
  LOGO_IMAGE = 'logo-image',
  LOGO_IMAGE_LARGE = 'logo-image-large',
  BACKGROUND_IMAGE = 'background-image',
  LINKED_CONTENT = 'attract-url',
  PROMO_CODE_IMAGE = 'promo-code-image'
}

export interface MediaType {
  name:
    | 'Slideshow'
    | 'Video'
    | 'Disable Media'
    | 'Inactive Page Image'
    | 'Splash Page Image'
    | 'Client Logo Image - Small'
    | 'Client Logo Image - Large'
    | 'Background Image'
    | 'Linked Content'
    | 'Promo Code Images';
  value:
    | 'attract-image'
    | 'attract-video'
    | 'upper-image'
    | 'upper-video'
    | 'disable-media'
    | 'inactive-image'
    | 'splash-image'
    | 'logo-image'
    | 'logo-image-large'
    | 'background-image'
    | 'attract-url'
    | 'promo-code-image';
  path?: 'inactive_images' | 'splash_images' | 'logo_images' | 'background_images' | 'promo_code_images';
}

export interface MediaResponse {
  id: string;
  name: string;
  s3Name: string;
  priority?: number;
  imageName?: string;
}
export interface ConfigurationMediaProps {
  configuration: Configuration;
}

export interface CIMediaProps {
  environment: ClientIntegration | null;
}

export interface DisabledMediaProps {
  configuration: Configuration;
  previewUrl: string;
  activeImage: MediaResponse;
  onDelete: (param: MediaResponse) => void;
}

export interface ImageEditDrawerProps {
  isOpen: boolean;
  image: MediaResponse;
  imageType: string;
  configurationId: string;
  onSuccess: (response: MediaResponse) => void;
  onClose: () => void;
  halfPreview?: boolean;
}

export interface ImageUploadOverlayTypes {
  onCancel: () => void;
  onSuccess: (response: MediaResponse) => void;
  halfPreview?: boolean;
  imageType: string;
  imageName?: string;
  clientIntegrationId?: string | null;
  configurationId?: string | null;
}

export interface SlideshowImageListProps {
  id: string;
  slideShowImages: MediaResponse[];
  previewUrl: string;
  activeImage: MediaResponse | null;
  isActive: boolean;
  mediaType: MediaTypes;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parentObj: any;
  configuration: Configuration;
  setActiveImage: (image: MediaResponse) => void;
  onAddImageClick: () => void;
  onImageEditClick: (s3Name: string, name: string, imageId: string) => void;
  onDelete: (param: MediaResponse) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateConfig: (payload: any) => void;
}

export interface VideoMediaListProps {
  isActive: boolean;
  activeImage: MediaResponse | null;
  mediaType: MediaTypes;
  setActiveImage: (image: MediaResponse) => void;
  onSuccess: (response: MediaResponse) => void;
  onDelete: (param: MediaResponse) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateConfig: (payload: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uploadVideo: (payload: any) => void;
}
